var name = {};
module['exports'] = name;
name.first_name = require("./first_name");
name.female_first_name = require("./feminine_name");
name.male_first_name = require("./masculine_name");
name.last_name = require("./last_name");
name.prefix = require("./prefix");
name.suffix = require("./suffix");
name.name = require("./name");